export default __webpack_public_path__ + "static/media/car-left-side.2c5a1afc.svg";